import type { ReactNode } from "react";

import { colorsPalettes } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

type AccountSignalTypeIconProps = {
    children: ReactNode;
};

export const AccountSignalTypeIcon = ({ children }: AccountSignalTypeIconProps) => (
    <Flex
        alignItems="center"
        justifyContent="center"
        width="32px"
        height="32px"
        borderRadius="10px"
        background={colorsPalettes.carbon[50]}
        flexShrink={0}
    >
        {children}
    </Flex>
);
